// 401 từ BE → event toàn cục để AuthWrapper logout + redirect /login.
// Trước đây: handleResponse trả error.message='Unauthorized' (BE) → UI render thẳng banner đỏ "Unauthorized" tiếng Anh thô (xem screenshot Lan khuê, Phúc Nguyễn). Đại lý không biết phải làm gì.
// Sau đây: handleUnauthorized() được handleResponse gọi → dispatch event → AuthWrapper clear session + redirect /login + báo "Phiên hết hạn".

const AUTH_EXPIRED_EVENT = 'auth:expired';

let lastTriggerTs = 0;

export function handleUnauthorized(reason = 'token_invalid') {
  // Debounce: nhiều API song song 401 chỉ trigger 1 lần
  const now = Date.now();
  if (now - lastTriggerTs < 2000) return;
  lastTriggerTs = now;

  try {
    localStorage.removeItem('thm_auth');
    localStorage.removeItem('thm_access_token');
  } catch {
    // localStorage không khả dụng (private mode) → ignore
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT, { detail: { reason } }));
  }
}

export const AUTH_EVENT_NAME = AUTH_EXPIRED_EVENT;
